if (!window._hmt) window._hmt = [];
const reportUrl = 'https://tj2.mini1.cn'

export default {
  /**
   * 初始化
   * @param {*} strict 
   * 默认严格模式，即按 k,v1-v5 上报的方式走
   * strict = false 时，可随意定制 key；但不走内部大数据上报，只走百度统计
   * @param {*} autoCheckSys 自动识别v6参数。即PC或移动端
   * @param commonParams 在 strict 为 false 时启用
   */
  init (options = {
    strict: true, 
    autoCheckSys: true, 
    sysMap: {
      pc: 'PC',
      android: 'H5',
      iphone: 'H5'
    },
    infokey: '',
    commonParams: null
  }) {
    this.strict = !!options.strict
    this.reportInner = this.strict
    this.autoCheckSys = options.autoCheckSys
    this.sysMap = options.sysMap
    this.commonParams = options.commonParams || {}
    this.infokey = options.infokey
  },
  _params: null,
  getCommonStatParams () {
    if (!this._params) {
      const mUserNavigator = navigator.userAgent.toLowerCase().match(/iphone|android/)
      let device = (mUserNavigator && mUserNavigator[0]) || 'pc'
      let commonParams = this.getSessionStorageParams()
      if (!commonParams) commonParams = this.getUrlParams();
      let { uin, apiid, ver, country, lang } = commonParams;
      if (this.strict) {
        this._params = `v1=${uin}&v2=${apiid}&v3=${ver}&v4=${country}&v5=${lang}`;
      } else {
        for (let key in this.commonParams) {
          this._params += `&${key}=${this.commonParams[key]}`
        }
        this._params = this._params.slice(1)
      }
      if (this.autoCheckSys) {
        this._params += '&' + (this.strict ? 'v6' : 'device') + `=${this.sysMap[device]}`
      }
    }
    return this._params
  },
  urlObj: null,
  getUrlParams () {
    if (!this.urlObj) {
      let _search = location.search.slice(1).split("=")
      for (let i = 0; i < _search.length; i++) {
        let tmp = _search.splice("&");
        this.urlObj[tmp[0]] = tmp[1];
      }
    }
    return this.urlObj
  },
  sessionObj: null,
  getSessionStorageParams () {
    if (this.sessionObj) return this.sessionObj
    if (this.infokey) {
      this.sessionObj = JSON.parse(sessionStorage.getItem(this.infokey));
    } else {
      let authInfo = sessionStorage.getItem("authinfo");
      if (authInfo) {
        return this.sessionObj = JSON.parse(authInfo)
      }
      let uin = sessionStorage.getItem('uin');
      let apiid, ver, country, lang;
      if (uin) {
        apiid = sessionStorage.getItem('apiid')
        ver = sessionStorage.getItem('ver')
        country = sessionStorage.getItem('country')
        lang = sessionStorage.getItem('lang')
        this.sessionObj = { uin, apiid, ver, country, lang, ...this.sessionObj };
      }
    }
    return this.sessionObj
  },
  /**
   * 上报到内部大数据平台
   */
  reportLog (options) {
    var logImg = new Image();
    logImg.src = reportUrl + '/miniworld?' + `${this.getCommonStatParams()}&${options}`;
  },
  log (action, k = 0, params) {
    let urlparams = new URLSearchParams()
    for (let key in params) {
      urlparams.append(key, params[key])
    }
    urlparams = urlparams.toString()
    _hmt && _hmt.push(['_trackEvent', action, k, this.getCommonStatParams(), urlparams]);
    this.strict && this.reportLog(urlparams + `&k=${k}`)
  }
}
